import { __assign, __extends } from "tslib";
import React from 'react';
import { ProGalleryRenderer } from 'pro-gallery';
var ProGalleryFullscreenMock = /** @class */ (function (_super) {
    __extends(ProGalleryFullscreenMock, _super);
    function ProGalleryFullscreenMock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProGalleryFullscreenMock.prototype.render = function () {
        var blueprint = this.props.directFullscreenMockBlueprint.blueprint;
        return (React.createElement(ProGalleryRenderer, __assign({}, this.props, blueprint)));
    };
    return ProGalleryFullscreenMock;
}(React.Component));
export default ProGalleryFullscreenMock;
//# sourceMappingURL=ProGalleryFullscreenMock.js.map